import { executeCapability } from '../utils/capabilityExecute'

export type ApiKeyRecord = {
  id: string
  name: string
  keyPrefix: string
  allowedCapabilities: string[]
  enabled: boolean
  expiresAt: string | null
  lastUsedAt: string | null
  createdBy: string | null
  updatedBy: string | null
  createdAt: string | null
  updatedAt: string | null
}

export type CapabilityCatalogGroup = {
  domain: string
  label: string
  capabilities: string[]
}

export type CreateOrRotateResult = {
  apiKey: string
  key: ApiKeyRecord
  warning: string
}

export const apiKeysService = {
  async catalog(): Promise<CapabilityCatalogGroup[]> {
    const out = await executeCapability<{ groups: CapabilityCatalogGroup[] }>({
      app: 'admin',
      capability: 'apiKeys.catalog',
      input: {},
    })
    return out?.groups || []
  },

  async list(): Promise<ApiKeyRecord[]> {
    const out = await executeCapability<{ data: ApiKeyRecord[] }>({
      app: 'admin',
      capability: 'apiKeys.list',
      input: {},
    })
    return out?.data || []
  },

  async create(input: {
    name: string
    allowedCapabilities?: string[]
    expiresAt?: string | null
  }): Promise<CreateOrRotateResult> {
    return executeCapability<CreateOrRotateResult>({
      app: 'admin',
      capability: 'apiKeys.create',
      input,
    })
  },

  async update(input: {
    id: string
    name?: string
    allowedCapabilities?: string[]
    enabled?: boolean
    expiresAt?: string | null
  }): Promise<ApiKeyRecord> {
    const out = await executeCapability<{ key: ApiKeyRecord }>({
      app: 'admin',
      capability: 'apiKeys.update',
      input,
    })
    return out.key
  },

  async rotate(id: string): Promise<CreateOrRotateResult> {
    return executeCapability<CreateOrRotateResult>({
      app: 'admin',
      capability: 'apiKeys.rotate',
      input: { id },
    })
  },

  async revoke(id: string): Promise<ApiKeyRecord> {
    const out = await executeCapability<{ key: ApiKeyRecord }>({
      app: 'admin',
      capability: 'apiKeys.revoke',
      input: { id },
    })
    return out.key
  },
}
